"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.authenticateByToken = authenticateByToken;
var _jsonpRequest = require("../../../browser/utils/jsonpRequest");
var _events = require("../../types/events");
var _view = require("../../types/view");
var _view2 = require("../view");
var _tracking = require("../../utils/tracking");
var _phoneAuth = require("../../types/phoneAuth");
var _authorizeUserByToken = require("../../repositories/users/v1/authorize-user-by-token");
var _action_types = require("../../constants/action_types");
var _rememberedAccounts = require("../../utils/rememberedAccounts");
var _rememberedAccounts2 = require("../../types/rememberedAccounts");
var _formatString = require("../../utils/formatString");
function authenticateByToken(_ref) {
  let {
    email,
    password,
    phone
  } = _ref;
  return async (dispatch, getState, context) => {
    dispatch({
      status: _phoneAuth.EAuthenticateByTokenStatus.Loading,
      type: _action_types.PHONE_AUTH_AUTHENTICATE_BY_TOKEN,
      account: email
    });
    try {
      const {
        phoneAuth: {
          registerOrAuth: {
            temporaryToken
          }
        },
        isRememberAccountsFlow,
        source
      } = getState();
      const res = await (0, _authorizeUserByToken.fetchAuthorizeUserByToken)({
        httpApi: context.httpApi,
        parameters: {
          email,
          password,
          temporaryToken
        },
        config: {
          requestConfig: {
            headers: [['Content-Type', 'application/json']],
            withCredentials: true
          }
        }
      });
      if (res.statusCode === 200) {
        const {
          logOnUrl,
          token,
          needCheckPassword
        } = res.response;
        if (needCheckPassword) {
          dispatch({
            type: _action_types.PHONE_AUTH_AUTHENTICATE_BY_TOKEN,
            status: _phoneAuth.EAuthenticateByTokenStatus.Suspended
          });
          dispatch((0, _view2.changeView)(_view.EActiveView.ConfirmSelectedAccount));
          return;
        }
        try {
          await (0, _jsonpRequest.jsonpRequest)(`${logOnUrl}?login=${encodeURIComponent(email)}&token=${token}&persistent=true`);
          dispatch({
            status: _phoneAuth.EAuthenticateByTokenStatus.Succeed,
            type: _action_types.PHONE_AUTH_AUTHENTICATE_BY_TOKEN
          });
          context.emitter.emit(_events.EEventType.AuthenticateSucceed);
          (0, _tracking.trackAuthenticateSuccess)({
            socialType: 'email',
            source
          });
          if (isRememberAccountsFlow) {
            if (phone) {
              (0, _rememberedAccounts.saveAccount)({
                type: _rememberedAccounts2.ERememberedAccountType.Phone,
                value: (0, _formatString.formatPhoneWithSpecialChars)(phone)
              });
            } else {
              (0, _rememberedAccounts.saveAccount)({
                type: _rememberedAccounts2.ERememberedAccountType.Email,
                value: email
              });
            }
          }
        } catch (e) {
          context.logger.error(e, {
            domain: 'auth-widget.api.authenticateByToken#logon'
          });
          dispatch({
            type: _action_types.PHONE_AUTH_AUTHENTICATE_BY_TOKEN,
            status: _phoneAuth.EAuthenticateByTokenStatus.Failed,
            error: 'Произошла непредвиденная ошибка'
          });
          if (!password) {
            dispatch((0, _view2.changeView)(_view.EActiveView.AccountSelectError));
          }
        }
        return;
      } else if (res.statusCode === 400 && res.response.errors.some(error => error.code.includes('tokenExpired'))) {
        dispatch({
          type: _action_types.PHONE_AUTH_AUTHENTICATE_BY_TOKEN,
          status: _phoneAuth.EAuthenticateByTokenStatus.Failed,
          error: res.response.message
        });
        dispatch((0, _view2.changeView)(_view.EActiveView.TokenExpiredError));
      } else if (res.statusCode === 400 && res.response.errors.some(error => error.code.includes('invalidPassword') || error.code.includes('passwordInvalidated'))) {
        dispatch({
          type: _action_types.PHONE_AUTH_AUTHENTICATE_BY_TOKEN,
          status: _phoneAuth.EAuthenticateByTokenStatus.Failed,
          error: res.response.message
        });
      } else {
        context.logger.error(`Непредвиденая ошибка, response: ${JSON.stringify(res.response)}`);
        dispatch({
          type: _action_types.PHONE_AUTH_AUTHENTICATE_BY_TOKEN,
          status: _phoneAuth.EAuthenticateByTokenStatus.Failed,
          error: 'Произошла непредвиденная ошибка'
        });
        if (!password) {
          dispatch((0, _view2.changeView)(_view.EActiveView.AccountSelectError));
        }
      }
    } catch (error) {
      context.logger.error(error, {
        domain: 'auth-widget.api.authenticateByToken'
      });
      dispatch({
        type: _action_types.PHONE_AUTH_AUTHENTICATE_BY_TOKEN,
        status: _phoneAuth.EAuthenticateByTokenStatus.Failed,
        error: 'Произошла непредвиденная ошибка'
      });
      if (!password) {
        dispatch((0, _view2.changeView)(_view.EActiveView.AccountSelectError));
      }
    }
  };
}